import { observable } from "@legendapp/state";

import { datasources$ } from "./datasources.crud";
import type { Datasource } from "./datasources.types";

/**
 * The default datasource for new datasets. Prefers the first non-managed
 * (bring-your-own) datasource so the auto-provisioned Mora-managed warehouse
 * is only auto-selected when it is the org's only datasource.
 */
export const firstDatasource$ = observable<Datasource | null>(() => {
  const entries = Object.values(datasources$.get() ?? {});
  if (entries.length === 0) return null;
  return entries.find((d) => !d?.managed) ?? entries[0] ?? null;
});
